// Dependencies
import axios from "axios";

// Services
import apiErrorHandling from "./errorHandling";

const leadsApi = axios.create({
    baseURL: process.env.REACT_APP_LEADS_API_URL
});

leadsApi.interceptors.response.use(
    (response) => response,
    async (error) => apiErrorHandling(error)
);

export default leadsApi;
